import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { _3_DAYS } from "../../../constants/durations";
import { useSpace } from "../../../hooks/useSpace";
import { OpenPendingItemWithSubTopic } from "../../../types";
import { keys } from "./keys";

async function fetchOpenPendingItems(spaceId: string): Promise<OpenPendingItemWithSubTopic[]> {
  const { data, error } = await apiClient
    .from('subject_pending_items')
    .select('*, sub_topics!inner(id, name, topics!inner(space_id))')
    .eq('state', 'pending')
    .eq('sub_topics.topics.space_id', spaceId)
    .order('created_at', { ascending: true });

  if (error) {
    throw error;
  }

  return (data ?? []) as unknown as OpenPendingItemWithSubTopic[];
}

export function useGetOpenPendingItems() {
  const { currentSpace } = useSpace();

  return useQuery({
    queryKey: keys.openPendingItems(currentSpace?.id ?? ''),
    queryFn: () => fetchOpenPendingItems(currentSpace!.id),
    enabled: !!currentSpace?.id,
    staleTime: _3_DAYS,
  });
}
